export const hubPageLocationType = [
  'HUB',
  'VENDING MACHINE',
  'MEGAHUB',
  'MEGAHUB 2.0',
  'DIGITAL GOODS',
  'VIRTUAL',
  'ASTRO OFFLINE',
]
export const warehousePageLocationType = ['WAREHOUSE', 'OFFICE']

export const locationTypeOptions = [
  { location_type: `ASTRO OFFLINE`, value: `astro offline`, exportValue: 'ASTROOFFLINE' },
  { location_type: `HUB`, value: `hub`, exportValue: 'HUB' },
  { location_type: `MEGAHUB`, value: `megahub`, exportValue: 'MEGAHUB' },
  { location_type: `MEGAHUB 2.0`, value: `megahub 2.0`, exportValue: 'MEGAHUB_2_0' },
  { location_type: `OFFICE`, value: `office`, exportValue: 'OFFICE' },
  { location_type: `WAREHOUSE`, value: `warehouse`, exportValue: 'WAREHOUSE' },
  { location_type: `VENDING MACHINE`, value: `vending machine`, exportValue: 'VENDINGMACHINE' },
  { location_type: `VIRTUAL`, value: `virtual`, exportValue: 'VIRTUAL' },
]
